import { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../utils'
import CompleteOverallStrategy from './CompleteOverallStrategy'
import SimplifiedOverallStrategy from './SimplifiedOverallStrategy'

function Overall(props) {
  const {
    config,
    config: { isSpendown, spendDownModeling },
  } = props.store
  useEffect(() => {
    if (isSpendown || spendDownModeling) {
      props.navigate('/spending', { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isSpendown) {
    return null
  }

  if (config.template.overallPageComponent === 'Overall') {
    return <CompleteOverallStrategy />
  }

  if (config.template.overallPageComponent === 'Simplified') {
    return <SimplifiedOverallStrategy />
  }

  return null
}

export default withRouterProps(inject('store')(observer(Overall)))
